/**
 * Teamspace chooser — the SUB-MENU shell (a row inside a parent `DropdownMenu`).
 *
 * The list itself lives in `TeamScopeList` and is shared with the standalone top-bar shell
 * (`TeamScopeButton`) — see that file for why this is a shell-only component. This shell stays for
 * `EmergencyTopBar` (N-Q5: that bar has no room for a top-bar control), and for the flag-off path
 * where `UserMenu` still renders it (`TOP_NAV_TEAM_SWITCHER`).
 */

import { useTranslation } from 'react-i18next';
import {
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubTrigger,
  DropdownMenuSubContent,
} from '@scio3/ui';
import { useTeamNoun } from '@/hooks/useTeamNoun';
import { TeamScopeList, useCanSwitchTeamScope, useTeamScopeLabel } from './TeamScopeList';

export function TeamSwitcher() {
  const { t } = useTranslation();
  const { noun } = useTeamNoun();
  const canSwitchTeamScope = useCanSwitchTeamScope();
  const scopeLabel = useTeamScopeLabel();

  if (!canSwitchTeamScope) return null;

  return (
    <>
      <DropdownMenuSeparator />
      <DropdownMenuSub>
        <DropdownMenuSubTrigger
          className="cursor-pointer"
          data-testid="team-switcher-trigger"
          aria-label={t('Switch {{noun}}', { noun })}
        >
          {noun} ({scopeLabel})
        </DropdownMenuSubTrigger>
        <DropdownMenuSubContent className="w-72">
          <TeamScopeList />
        </DropdownMenuSubContent>
      </DropdownMenuSub>
      <DropdownMenuSeparator />
    </>
  );
}
